import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFileSave = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={15}
    fill="none"
    viewBox="0 0 12 15"
    {...props}
  >
    <path
      fill="#999"
      d="m8.6 10.7-.533-.533a.583.583 0 0 0-.85 0 .583.583 0 0 0 0 .85l1.569 1.569q.18.18.417.18a.56.56 0 0 0 .414-.183l1.566-1.566a.583.583 0 0 0 0-.85.583.583 0 0 0-.85 0L9.8 10.7V8.799a.58.58 0 0 0-.171-.427.58.58 0 0 0-.425-.172.59.59 0 0 0-.429.172.57.57 0 0 0-.175.427zm-1.2 3.1h3.595a.59.59 0 0 1 .605.596.59.59 0 0 1-.172.429A.58.58 0 0 1 11 15H7.405a.59.59 0 0 1-.605-.597q0-.252.173-.428A.57.57 0 0 1 7.4 13.8m-6-1.2q-.484 0-.841-.358A1.15 1.15 0 0 1 .2 11.4V1.8q0-.483.359-.842Q.917.6 1.4.6h4.7q.237 0 .452.083.215.084.398.267l2.5 2.5a1.15 1.15 0 0 1 .35.85v2.1q0 .255-.171.427A.57.57 0 0 1 9.204 7a.59.59 0 0 1-.429-.173A.58.58 0 0 1 8.6 6.4V4.6H6.7a.87.87 0 0 1-.637-.263A.87.87 0 0 1 5.8 3.7V1.8H1.4v9.6h3.8q.255 0 .428.172a.57.57 0 0 1 .172.425.59.59 0 0 1-.172.428.58.58 0 0 1-.428.175z"
    />
  </svg>
);
export default SvgFileSave;
